import React from "react";

import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import { useMemo } from "react";
import accessoriesService from "../../../services/accessories.service";

const defaultKeys = [
  {
    title: "نام",
    field: "name",
    active: true,
  },
];

export default function AccessoryColorsPage(props) {
  const { colors, id, name } = props;
  const deleteItem = (item) => {
    return accessoriesService.deleteAccessoryColor(item.id);
  };
  const headerCells = useMemo(
    () => [
      {
        field: "name",
        title: "نام",
        mainField: true,
      },
      {
        field: "price",
        title: "قیمت",
        currency: true,
      },
      {
        field: "count",
        title: "موجودی",
      },
      {
        field: "isActive",
        title: "وضعیت",
        renderer: (val) => (val ? "فعال" : "غیر فعال"),
      },
    ],
    []
  );

  return (
    <div className="p-3">
      <DataTable
        backend={accessoriesService.getAccessoriesColorsUrl + id}
        headCells={headerCells}
        data={colors}
        rowActions={[
          {
            modalProps: { maxWidth: "md" },
            icon: <EditIcon />,
            modalContent: (p) => <FormModalContent {...p} parent={props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "md" },
            icon: <AddIcon />,
            tooltip: "ایجاد اکسسوری",
            modalContent: (p) => <FormModalContent {...p} parent={props} />,
          },
        ]}
        searchKeys={defaultKeys}
        title={`رنگ‌های اکسسوری ${name}`}
      />
    </div>
  );
}
